import { COLOR1, COLOR6, RADIO_COLOR } from '../../../constants';

export const CustomDobStyles = {
  label_title: {
    marginBottom: '10px !important',
    letterSpacing: '0.1px',
    lineHeight: '18px',
    textAlign: 'left',
    '@media (max-width:600px)': {
      marginBottom: '10px',
    },
  },
  select_inputs_err: {
    '& fieldset': {
      borderRadius: '6px',
      border: '1px solid #FD0000 !important',
    },
  },
  dob_month_year_select: {
    '& .MuiSelect-outlined': {
      paddingRight: '10px',
      paddingLeft: '10px',
    },
    '& .MuiSelect-icon': {
      '@media (min-width:960px) and (max-width:1030px)': {
        right: 0,
      },
      '@media (max-width:370px)': {
        right: -5,
      },
    },
  },
  dob_month_year_select_disabled: {
    background: '#F3F3F3',
    // border: 'none !important',
    height: '48px',
    '& .MuiOutlinedInput-input': {
      padding: '11.5px 14px',
    },
  },
  dob_month_year_select_vi: {
    '& .MuiSelect-outlined': {
      paddingRight: '10px',
      paddingLeft: '10px',
      fontSize: '13px',
    },
    '& .MuiSelect-icon': {
      right: '5px',
      '@media (min-width:960px) and (max-width:1080px)': {
        right: -5,
      },
      '@media (max-width:370px)': {
        right: -5,
      },
    },
  },
  dob_day_select_vi: {
    '& .MuiSelect-outlined': {
      paddingRight: '10px',
    },
    '@media (max-width:650px)': {
      '& .MuiSelect-selectMenu': {
        overflow: 'visible',
      },
    },
  },
  dob_day_select: {
    '& .MuiSelect-outlined': {
      paddingRight: '10px',
      paddingLeft: '10px',
    },
  },
  datePickerStyle: {
    margin: '-35px 154px 26px 236px',
  },
  dob_container: {
    '@media (max-width:600px)': {
      display: 'flex',
      justifyContent: 'space-between',
    },
  },
  date_of_birth_select: {
    background: 'rgba(85, 88, 88, 0.02) 0% 0% no-repeat padding-box',
    opacity: 1,
    height: '41px',
    fontWeight: 300,
    fontStyle: 'normal',
    fontSize: '14px',
    lineHeight: '16px',
    textAlign: 'left',
    letterSpacing: '0.1px',
    color: COLOR1,
    '& .MuiOutlinedInput-input': {
      paddingTop: '11.5px',
      paddingBottom: '11.5px',
    },
  },
  select_icon: {
    color: RADIO_COLOR,
    opacity: 1,
    right: '4px',
  },

  outlined_inputs: {
    background: '#ffffff',
    textAlign: 'left',
    opacity: 1,
    boxSizing: 'border-box',
    height: '48px',
    font: 'normal normal 300 14px/16px Arial, Sans-serif',
    border: '1px solid #e4e9f2',
    letterSpacing: '0.1px',
  },
  outlined_inputs_input: {
    padding: '12.5px 16px',
    color: '#000000',
  },
  outlined_inputs_fieldset: {
    borderRadius: '6px',
    border: '0',
  },
  outlined_inputs_placeholder: {
    color: '#444444',
    opacity: 1,
  },
  outlined_inputs_transaction_placeholder: {
    color: '#444444',
    opacity: 1,
  },
  error: {
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '12px',
    lineHeight: '16px',
    color: '#fd0000',
    marginTop: '2px',
  },
  disableError: {
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '12px',
    lineHeight: '16px',
    color: '#bdbdbd',
    marginTop: '2px',
  },
  dobIconContainer: {
    display: 'flex',
    justifyContent: 'end',
    position: 'relative',
    top: '-23px',
    right: '15px',
  },
  dobContainer: {
    borderRadius: '6px',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
  },
  // Media Queries (can be handled differently in JS-in-CSS)
  '@media (max-width: 600px)': {
    label_title: {
      marginBottom: '5px',
      color: '#444444',
      fontSize: '14px',
      fontStyle: 'normal',
      fontWeight: 700,
      lineHeight: '18px',
      textAlign: 'left',
      letterSpacing: '0.1px',
    },
  },
  '@media (min-width: 1200px) and (max-width: 1280px)': {
    outlined_inputs_transaction_input: {
      paddingLeft: '8px',
    },
  },
};
